export default __webpack_public_path__ + "static/media/344.57931586.png";